/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_EmptyInputs */

const cs_projects_empty = /** @type {(inputs: Projects_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné developerské projekty.`)
};

const en_projects_empty = /** @type {(inputs: Projects_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No developer projects yet.`)
};

/**
* | output |
* | --- |
* | "No developer projects yet." |
*
* @param {Projects_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const projects_empty = /** @type {((inputs?: Projects_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_projects_empty(inputs)
	return cs_projects_empty(inputs)
});